import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { spassuCodeApiRef, SpassuCodeClient } from './api';

export const spassuCodePlugin = createPlugin({
  id: 'spassu-code',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: spassuCodeApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new SpassuCodeClient(discoveryApi, fetchApi),
    }),
  ],
});

export const SpassuCodePage = spassuCodePlugin.provide(
  createRoutableExtension({
    name: 'SpassuCodePage',
    component: () =>
      import('./components/SpassuCodePage').then(m => m.SpassuCodePage),
    mountPoint: rootRouteRef,
  }),
);
